import { BaseApi } from './base.api.js';

export class InterestedPartyApi extends BaseApi {
    constructor(client) {
        super(client, '/interested-party');
    }
}
